/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export enum ClarityDialogSize {
    FULL = 'modal-full',
    XLARGE = 'modal-xl',
    LARGE = 'modal-lg',
    MEDIUM = 'modal-md',
    SMALL = 'modal-sm',
}